'use strict';

// API
import {
  submitPayment,
  submitCouponCode,
  getOrder,
} from 'api/review';

// Actions
const actions = {
  submitPayment(context, model) {
    return submitPayment(model);
  },
  submitCouponCode(context, model) {
    return submitCouponCode(model);
  },
  getOrder(context, model) {
    return getOrder(model);
  },
};

export default {
  namespaced: true,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/payment.js